import { OverflowMenuHorizontal } from '@carbon/icons-react';
import * as React from 'react';
import { Menu, MenuItems } from 'vet-bones/design-system/components';

import {
  SDU_DASHBOARD_ENDPOINT_ACTIONS_MENU,
  SDU_DASHBOARD_ENDPOINT_ACTIONS_MENU_ITEM,
} from 'src/ui/constants/testIds';
import { SduMenuActions } from 'src/ui/containers/endpoints/SduMenuActions';
import { useHasReadLogsPermissions } from 'src/ui/containers/endpoints/utils/useHasReadLogsPermissions';
import { useSduTrackingStatus } from 'src/ui/containers/endpoints/utils/useSduTrackingStatus';
import { Connection } from 'src/ui/graph/types';

interface SduEndpointActionMenuProps {
  connection: Connection;
}

export const SduEndpointActionMenu: React.VFC<SduEndpointActionMenuProps> = ({
  connection,
}) => {
  const {
    isSduSupported,
    disabled: isSduSyncDisabled,
    inProgress: isSduSyncInProgress,
  } = useSduTrackingStatus(connection);

  const hasSduPermissions = useHasReadLogsPermissions(
    connection,
    isSduSupported
  );

  if (!isSduSupported) {
    return null;
  }

  return (
    <Menu
      leftIcon={OverflowMenuHorizontal}
      menu={
        <MenuItems>
          <SduMenuActions
            canReadLogs={hasSduPermissions}
            connection={connection}
            downloadTestId={SDU_DASHBOARD_ENDPOINT_ACTIONS_MENU_ITEM(
              'download-sdu'
            )}
            isSyncDisabled={isSduSyncDisabled}
            isSyncInProgress={isSduSyncInProgress}
            syncTestId={SDU_DASHBOARD_ENDPOINT_ACTIONS_MENU_ITEM('sync-sdu')}
          />
        </MenuItems>
      }
      size="sm"
      testId={SDU_DASHBOARD_ENDPOINT_ACTIONS_MENU}
    />
  );
};
